// Configuration loaded from config.json file
// This file is read once when the application starts and blocks until loaded

// Default configuration as fallback
const defaultConfig = {
  apiBaseUrl: 'http://localhost:3001',
  appName: 'Dissona',
  version: '1.0.0',
  features: {
    enableDebugMode: false,
    enableAnalytics: false,
  },
  ui: {
    theme: 'dark',
    language: 'en',
  },
};

// Global configuration object - will be populated during app initialization
let appConfig = null;

// Function to initialize configuration synchronously
// This will be called during app startup and block until config is loaded
export const initializeConfig = () => {
  return new Promise((resolve, _reject) => {
    fetch('/config.json')
      .then((response) => {
        if (!response.ok) {
          console.warn(
            'Could not load config.json, using default configuration',
          );
          appConfig = { ...defaultConfig };
          resolve(appConfig);
          return;
        }
        return response.json();
      })
      .then((config) => {
        if (config) {
          appConfig = { ...defaultConfig, ...config };
          // eslint-disable-next-line no-console
          console.log('Configuration loaded successfully:', appConfig);
        }
        resolve(appConfig);
      })
      .catch((error) => {
        console.error('Error loading configuration:', error);
        console.warn('Using default configuration');
        appConfig = { ...defaultConfig };
        resolve(appConfig);
      });
  });
};

// Synchronous function to get configuration
// Throws error if config not initialized yet
export const getConfig = () => {
  if (!appConfig) {
    throw new Error(
      'Configuration not initialized yet. Call initializeConfig() first.',
    );
  }
  return appConfig;
};

// Synchronous function to build API URLs
export const getApiUrl = (endpoint) => {
  if (!appConfig) {
    throw new Error(
      'Configuration not initialized yet. Call initializeConfig() first.',
    );
  }
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${appConfig.apiBaseUrl}/${cleanEndpoint}`;
};

// Absolute form of `getApiUrl`, for URLs that leave the app — a feed pasted
// into a podcast client, a link sent to someone. Behind the edge proxy
// `apiBaseUrl` is a relative prefix, so getApiUrl alone yields "/api/…", which
// means nothing outside the browser that produced it.
export const getPublicApiUrl = (endpoint) =>
  new URL(getApiUrl(endpoint), window.location.origin).href;

// Check if configuration is loaded
export const isConfigLoaded = () => {
  return appConfig !== null;
};

export default { initializeConfig, getConfig, getApiUrl, getPublicApiUrl, isConfigLoaded };
